import { render } from "./customArticleDetail.vue?vue&type=template&id=f9416a70"
import script from "./customArticleDetail.vue?vue&type=script&lang=js"
export * from "./customArticleDetail.vue?vue&type=script&lang=js"

import "./customArticleDetail.vue?vue&type=style&index=0&id=f9416a70&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__